import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import {
  AngularFirestoreModule,
  SETTINGS,
} from '@angular/fire/compat/firestore';
import {
  AngularFireFunctionsModule,
  USE_EMULATOR,
} from '@angular/fire/compat/functions';
import { AngularFirePerformanceModule } from '@angular/fire/compat/performance';
import {
  AngularFireStorageModule,
  BUCKET,
} from '@angular/fire/compat/storage';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AgGridModule } from '@ag-grid-community/angular';

import {
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LocalStorageService } from './core/localStorage/local-storage.service';
import { MaterialModule } from './core/modules/material/material.module';
import { AITPipesModule } from './core/modules/pipes/pipes.module';
import { UserLaneModule } from './core/modules/user-lane/user-lane.module';
import { ApiRequestInterceptorService } from './core/services/api-request-interceptor/api-request.interceptor';
import { ActiveJobProgressModule } from './modules/active-job-progress/active-job-progress.module';
import { LittlesisLicensingModule } from './modules/licensing/littlesis-licensing.module';
import { SyncHistoryModule } from './modules/sync-history/sync-history.module';

const shouldUseEmulator = () => environment.env === 'local';

// required for AOT compilation
export const HttpLoaderFactory = (http: HttpClient): TranslateHttpLoader => new TranslateHttpLoader(http);

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    ActiveJobProgressModule,
    AgGridModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFirePerformanceModule,
    AngularFireStorageModule,

    MaterialModule,
    MatMenuModule,
    AITPipesModule,
    SyncHistoryModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    UserLaneModule,
    LittlesisLicensingModule,
  ],
  providers: [
    { provide: BUCKET, useValue: environment.storage.bucketname },
    {
      provide: USE_EMULATOR,
      useValue: environment.useLocalFunctions ? ['localhost', 5001] : undefined,
    },
    {
      provide: SETTINGS,
      useValue: environment.useLocalFirestore
        ? {
            host: 'localhost:8080',
            ssl: false,
          }
        : undefined,
    },
    { provide: Window, useValue: window },
    LocalStorageService,
    {provide: HTTP_INTERCEPTORS, useClass: ApiRequestInterceptorService, multi: true}
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
